import SlotSelectionGrid from './SlotSelectionGrid';
import { useAvailableSlots } from '@/hooks';

export default function Slots() {
  const { sortedAvailableSlots, currentDate, location } = useAvailableSlots();

  if (!location?.timezone) return null;

  return (
    <div className="mb-8">
      {/* TODO: move to a modal like v2 */}
      {!currentDate && (
        <p className="mt-4 border-red-500 text-center text-lg font-light">
          No slot has been selected
        </p>
      )}
      <div>
        <SlotSelectionGrid slots={sortedAvailableSlots} />
      </div>
    </div>
  );
}
